import TRTC from "trtc-js-sdk";
let client;
let localStream;
let remoteStream;
let _incomingMessage = null;
let _localStreamElementId = null;
let isShareScreen = false;

export default {
    loginTRTC(localStreamElementId, incomingMessage) {
        _localStreamElementId = localStreamElementId;
        _incomingMessage = incomingMessage;          
        console.log(_incomingMessage,'-----------------------_incomingMessage');
        client = TRTC.createClient({
            mode: "live",
            streamId: _incomingMessage.streamId,
            userDefineRecordId: _incomingMessage.streamId,
            sdkAppId: parseInt(_incomingMessage.sdkAppId),
            userId: _incomingMessage.userId,
            userSig: _incomingMessage.userSig
        });
        localStream = TRTC.createStream({
            role: "anchor",
            userId: _incomingMessage.userId,
            audio: true,
            video: true,
            mirror:false,
        });
        localStream.setScreenProfile({ width: 1920, height: 1080, frameRate: 5, bitrate: 1600});
        localStream.initialize().then(function() {
            localStream.play(localStreamElementId);
            client.join({
                roomId: parseInt(_incomingMessage.roomId),
                privateMapKey: _incomingMessage.privateMapKey
            }).then(res => {
                client.publish(localStream);
            }).catch(err =>{
                console.log(err,'---------------------------join报错信息');
            })
        });
        localStream.on('screen-sharing-stopped', event => {
            client.unpublish(localStream);
            localStream.close();
            client.leave();
        });
        client.on("stream-added", event => {
            // console.log("stream-added---->", event);
            client.subscribe(event.stream);
        });
        client.on("stream-subscribed", event => {
            // console.log("stream-subscribed---->", event);
            let that = this;
            remoteStream = event.stream;
            remoteStream.play(localStreamElementId).then(function(response) {
                let _id = remoteStream.getId();
                let _tempEle = document.getElementById("player_" + _id);
                if (isShareScreen) {
                    that.closeLocalStream();
                } else {
                    _tempEle.style = "width:100%; height:100%; object-fit:cover;  display:none";
                }
            });
        });
        client.on("mute-audio", event => {
            // console.log("mute-audio---->", event);
        });
        /*
        client.on("stream-updated", event => {
            console.log("stream-updated---->", event);
        });
        client.on("stream-removed", event => {
            console.log("stream-removed---->", event);
        });
        client.on("error", error => {
            console.error("client error observed: " + error);
        });
         */
    },
    changeTrackSource(config) {
        let that = this;
        client.switchRole('anchor').then(function(response) {
            // console.log("角色切换--成功------>");
            client.unpublish(localStream);
            localStream.close();
            localStream = null;
            localStream = TRTC.createStream({
                userId: _incomingMessage.userId,
                ...config
            });
            localStream.setScreenProfile({ width: 1920, height: 1080, frameRate: 5, bitrate: 1600});
            localStream.initialize().then(function() {
                localStream.play(_localStreamElementId).then(function(response) {
                    that.closeRemoteStream();
                });
                client.publish(localStream);
            });
        }).catch(function(error) {
            // console.log("角色切换--失败------>");
        });
    },
    snapshot() {
        // localStream.getVideoFrame();
    },
    setMuteAudio() {
        localStream.muteAudio();
    },
    setUnmuteAudio() {
        localStream.unmuteAudio();
    },
    closeLocalStream() {
        // 显示远程的
        let _remoteId = remoteStream.getId();
        let _eleRemote = document.getElementById("player_" + _remoteId);
        _eleRemote.style = "width:100%; height:100%; object-fit:cover; display:block";
        // 关闭自己的
        let _localId = localStream.getId();
        let _eleLocal = document.getElementById("player_" + _localId);
        _eleLocal.style = "width:100%; height:100%; object-fit:cover;  display:none";
    },
    closeRemoteStream() {
        // 关闭远程的
        let _remoteId = remoteStream.getId();
        let _eleRemote = document.getElementById("player_" + _remoteId);
        _eleRemote.style = "width:100%; height:100%; object-fit:cover;  display:none";
        // 显示自己的
        let _localId = localStream.getId();
        let _eleLocal = document.getElementById("player_" + _localId);
        _eleLocal.style = "width:100%; height:100%; object-fit:cover; display:block";
    },
    setShareScreen() {
        isShareScreen = true;
    },
    logoutTRTC() {
        if (remoteStream) {
            remoteStream.stop();
            remoteStream.close();
        }
        localStream.stop();
        localStream.close();
        client.unpublish(localStream);
        client.leave();
    }
};
